<div style="margin-left: 5%; margin-right: 5%; 
  padding-right: 20px; margin-bottom: 5px; margin-top: 30px;">
    <div style="padding: 5px; text-align: center; margin-bottom: 20px;
        border-radius: 25px; background-color: #4b8cc5;">
        <h2 mat-dialog-title style="color: white; margin-bottom: 0px; margin-top: 0px;">Configuración</h2>
    </div>
</div>
<div style="margin-left: 5%; margin-right: 5%; padding-left: 20px;
    padding-right: 20px;">
    <table style="width: 100%;">
        <tr>
            <td style="width: 20%;">
                <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarCasillasMails()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Casillas de mails</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card>
            </td>
            <td style="width:5%;"></td>
            <td style="width: 20%;">
                <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarConsorcios()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Consorcios</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card>
            </td>
            <td style="width:5%;"></td>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarTiposMails()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Tipos de mails</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card> -->
            </td>
            <td style="width:5%;"></td>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarTiposSexo()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Tipos de sexo</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card> -->
            </td>
            <td style="width:5%; margin-bottom: 50px;"></td>
        </tr>
        <tr>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarObrasSociales()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Obras sociales</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card> -->
            </td>
            <td style="width:5%;"></td>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarProvincias()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Provincias</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card> -->
            </td>
            <td style="width:5%;"></td>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarLocalidad()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Localidades</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card> -->
            </td>
            <td style="width:5%;"></td>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarTiposTelefono()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Tipos de teléfono</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content> 
                </mat-card>-->
            </td>
            <td style="width:5%; margin-bottom: 50px;"></td>
        </tr>
        <tr>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarPrestaciones()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Prestaciones</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card> -->
            </td>
            <td style="width:5%;"></td>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarProvincias()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Provincias</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card> -->
            </td>
            <td style="width:5%;"></td>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarLocalidad()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Localidades</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content> 
                </mat-card>-->
            </td>
            <td style="width:5%;"></td>
            <td style="width: 20%;">
                <!-- <mat-card class="example-card"
                    style="margin-top: 7px; width: 100%; align-items: center; align-self: center; border-radius: 25px; cursor: pointer; "
                    class="example-card mat-elevation-z8">
                    <mat-card-content style="margin-left: 10px;">
                        <mat-card-title style="margin-left: -2vh;" (click)="mostrarTiposTelefono()">
                            <table>
                                <tr>
                                    <td>
                                        <img src="./assets/imagenes/logoFav.png" width="32" height="32">
                                    </td>
                                    <td style="width: 5%;"></td>
                                    <td>
                                        <strong style="font-size: 2.5vh;">Tipos de teléfono</strong>
                                    </td>
                                </tr>
                            </table>
                        </mat-card-title>
                    </mat-card-content>
                </mat-card> -->
            </td>
            <td style="width:5%; margin-bottom: 50px;"></td>
        </tr>
    </table>
</div>
